module.exports = "https://static.zego.com/_next/static/images/CarDesignedForYou-046aa6527646ab23a8bf5087c6e4b8e3.jpg";